module.exports = __webpack_public_path__ + "media/section1BgVideo.121acd52.mp4";